import React, { Component, useState, useEffect } from 'react';
import Dialog, { DialogContent, DialogTitle, DialogFooter, DialogButton } from '@material/react-dialog';
import TagManager from 'react-gtm-module';
import '@material/react-dialog/dist/dialog.css';
import Axios from 'axios';
import Zendesk, { ZendeskAPI } from 'react-zendesk';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import scrollToElement from 'scroll-to-element';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var Label = /*#__PURE__*/function (_Component) {
  function Label() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Label, _Component);
  var _proto = Label.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", null, "Test label from react-test-app ");
  };
  return Label;
}(Component);
var Label$1 = /*#__PURE__*/function (_Component) {
  function Label() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Label, _Component);
  var _proto = Label.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", null, "Test label1 from react-test-app ");
  };
  return Label;
}(Component);
var ModelHelper = /*#__PURE__*/function () {
  function ModelHelper() {}
  ModelHelper.validateNonEmpty = function validateNonEmpty(fieldValue, isArray) {
    if (isArray === void 0) {
      isArray = false;
    }
    if (fieldValue !== undefined && fieldValue !== null) {
      if (isArray || typeof fieldValue === 'string' || fieldValue instanceof String) {
        return fieldValue.length > 0;
      } else return true;
    }
    return false;
  };
  ModelHelper.validateEmpty = function validateEmpty(fieldValue) {
    if (fieldValue === undefined || fieldValue === null || fieldValue.length === 0) {
      return true;
    }
    return false;
  };
  return ModelHelper;
}();
var _GtmHelper;
var EVENT_CATEGORY_FORM = 'Form';
var EVENT_CATEGORY_GENERIC = 'Generic';
var EVENT_CATEGORY_ADDRESS = 'Address';
var eventSendStatus = {
  initialize: false,
  sendFormStart: false,
  sendFormComplete: false
};
var GtmHelper = /*#__PURE__*/function () {
  function GtmHelper() {}
  GtmHelper.buildDataLayerArgs = function buildDataLayerArgs(category, action, label, value, ni) {
    if (ni === void 0) {
      ni = false;
    }
    console.log("buildDataLayerArgs");
    if (label === undefined || label === null) {
      label = 'undefined';
    }
    if (value === undefined || value === null) {
      value = 'undefined';
    }
    return {
      dataLayer: {
        'event': 'gtm.event',
        'event-category': category,
        'event-action': action,
        'event-label': label,
        'event-value': value,
        'event-ni': ni
      },
      dataLayerName: 'PageDataLayer'
    };
  };
  GtmHelper.buildCustomDimensions = function buildCustomDimensions(cdsMap) {
    console.log('buildCustomDimensions');
    if (cdsMap === undefined || cdsMap === null || !(cdsMap instanceof Map)) {
      return null;
    }
    var dataLayer = {};
    cdsMap.forEach(function (value, key) {
      dataLayer[key] = value;
    });
    console.log(dataLayer);
    return {
      dataLayer: _extends({}, dataLayer),
      dataLayerName: 'PageDataLayer'
    };
  };
  GtmHelper.formDataLayerArgs = function formDataLayerArgs(action, label, value, ni) {
    return this.buildDataLayerArgs(EVENT_CATEGORY_FORM, action, label, value, ni);
  };
  return GtmHelper;
}();
_GtmHelper = GtmHelper;
GtmHelper.setup = function (gtmId) {
  var tagManagerArgs = {
    gtmId: gtmId,
    dataLayerName: 'PageDataLayer'
  };
  TagManager.initialize(tagManagerArgs);
  console.log("setup");
};
GtmHelper.sendError = function (errorMessage) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Error', errorMessage));
};
GtmHelper.sendErrorResolved = function (errorMessage) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Error resolved', errorMessage));
};
GtmHelper.sendFormStart = function (formType) {
  if (eventSendStatus.sendFormStart === false) {
    eventSendStatus.sendFormStart = true;
    TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Form start', formType, null, true));
  }
};
GtmHelper.sendFormComplete = function (formType) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Form complete', formType));
};
GtmHelper.sendStepSubmit = function (formType) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Step submit', formType));
};
GtmHelper.sendStepComplete = function (label) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Step complete', label));
};
GtmHelper.sendStepNavigateBack = function (label) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Step backwards', label));
};
GtmHelper.sendStepError = function (label, errorCount) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Step error', label, errorCount));
};
GtmHelper.sendModalOpen = function (label) {
  console.log('sendModalOpen from GtmHelper package');
  TagManager.dataLayer(_GtmHelper.buildDataLayerArgs(EVENT_CATEGORY_GENERIC, 'Modal open', label));
};
GtmHelper.sendModalClose = function (label) {
  TagManager.dataLayer(_GtmHelper.buildDataLayerArgs(EVENT_CATEGORY_GENERIC, 'Modal close', label));
};
GtmHelper.sendAddressSearchValidation = function (label, count) {
  if (count === void 0) {
    count = 0;
  }
  TagManager.dataLayer(_GtmHelper.buildDataLayerArgs(EVENT_CATEGORY_ADDRESS, 'Address search', label, count));
};
GtmHelper.sendAddressSearchAutoComplete = function () {
  TagManager.dataLayer(_GtmHelper.buildDataLayerArgs(EVENT_CATEGORY_ADDRESS, 'Autocomplete selection'));
};
GtmHelper.sendPromotionCodeApplied = function (promoCode) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Promotion applied', promoCode));
};
GtmHelper.sendPromotionCodeRemoved = function (promoCode) {
  TagManager.dataLayer(_GtmHelper.formDataLayerArgs('Promotion removed', promoCode));
};
GtmHelper.sendCustomDimensions = function (cdsMap) {
  console.log('send custom dimensions');
  var cdsArgs = _GtmHelper.buildCustomDimensions(cdsMap);
  if (cdsArgs !== null) {
    TagManager.dataLayer(cdsArgs);
  }
};
GtmHelper.sendGA4Login = function (message) {
  var cdsMap = new Map();
  cdsMap.set('event', 'login');
  cdsMap.set('segment', message ? message : 'undefined');
  cdsMap.set('method', 'Password');
  _GtmHelper.sendCustomDimensions(cdsMap);
};
GtmHelper.sendGA4Error = function (message) {
  var cdsMap = new Map();
  cdsMap.set('event', 'error');
  cdsMap.set('error_label', message ? message : 'undefined');
  _GtmHelper.sendCustomDimensions(cdsMap);
};
GtmHelper.sendGA4ModalOpen = function (title) {
  if (ModelHelper.validateNonEmpty(title)) {
    var cdsMap = new Map();
    cdsMap.set('event', 'modal_open');
    cdsMap.set('modal_title', title);
    _GtmHelper.sendCustomDimensions(cdsMap);
  }
};
GtmHelper.sendGA4ModalClose = function (title) {
  if (ModelHelper.validateNonEmpty(title)) {
    var cdsMap = new Map();
    cdsMap.set('event', 'modal_close');
    cdsMap.set('modal_title', title);
    _GtmHelper.sendCustomDimensions(cdsMap);
  }
};
GtmHelper.sendGA4Accordion = function (title) {
  var cdsMap = new Map();
  cdsMap.set('event', 'detail_expand');
  cdsMap.set('cta', title ? title : 'undefined');
  _GtmHelper.sendCustomDimensions(cdsMap);
};
GtmHelper.sendGA4ToggleSwitch = function (title, state) {
  var cdsMap = new Map();
  cdsMap.set('event', 'toggle_switch');
  cdsMap.set('toggle_title', title ? title : 'undefined');
  cdsMap.set('state', state ? state.toLowerCase() : 'undefined');
  _GtmHelper.sendCustomDimensions(cdsMap);
};
GtmHelper.sendGA4AddressSearch = function (response, count, isAutoComplete, postCode, suburb, availability) {
  var cdsMap = new Map();
  cdsMap.set('event', 'address_search');
  cdsMap.set('address_response', response ? response : 'undefined');
  cdsMap.set('address_count', count ? parseInt(count) : 'undefined');
  cdsMap.set('address_autocomplete', isAutoComplete ? isAutoComplete.toUpperCase() : 'undefined');
  cdsMap.set('postcode', postCode ? postCode : 'undefined');
  cdsMap.set('suburb', suburb ? suburb : 'undefined');
  cdsMap.set('service_availability', availability ? availability : 'undefined');
  _GtmHelper.sendCustomDimensions(cdsMap);
};
var Modal = /*#__PURE__*/function (_React$Component) {
  function Modal(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.onModalClose = function (e) {
      if (_this.props.onClose !== undefined) {
        if (_this.props.isVideo) {
          var videoContainer = _this.dialogContentRef.current;
          var iframe = videoContainer.getElementsByTagName('iframe')[0];
          var oldIframeSrc = iframe.getAttribute('src');
          iframe.setAttribute('src', oldIframeSrc);
        }
        _this.props.onClose(e);
      }
      if (Modal.isCancel(e) && _this.props.enableGtm === true) {
        GtmHelper.sendGA4ModalClose(_this.props.title);
      }
    };
    _this.onModalOkay = function (e) {
      if (_this.props.onOkay !== undefined) {
        _this.props.onOkay(e);
      }
      if (_this.props.enableGtm === true) {
        GtmHelper.sendModalClose(_this.props.title);
        GtmHelper.sendGA4ModalClose(_this.props.title);
      }
    };
    _this.onModalOpen = function (e) {
      if (_this.props.enableGtm === true) {
        GtmHelper.sendModalOpen(_this.props.title);
        GtmHelper.sendGA4ModalOpen(_this.props.title);
      }
      _this.dialogContentRef.current.parentElement.focus();
    };
    _this.onModalOpen = _this.onModalOpen.bind(_this);
    _this.onModalClose = _this.onModalClose.bind(_this);
    _this.onModalOkay = _this.onModalOkay.bind(_this);
    _this.dialogContentRef = React.createRef(null);
    return _this;
  }
  _inheritsLoose(Modal, _React$Component);
  Modal.isCancel = function isCancel(e) {
    var isCancel = false;
    if (e.target !== undefined) {
      if (e.target.title === 'Close' || e.target.innerText === 'Cancel' || e.target.innerText === 'Close' || e.target.innerText === 'No') {
        isCancel = true;
        e.preventDefault();
      }
    } else if (e === 'close') {
      isCancel = true;
    }
    return isCancel;
  };
  Modal.isConfirm = function isConfirm(e) {
    var isConfirm = false;
    if (e.target !== undefined) {
      if (e.target.innerText === 'Confirm' || e.target.innerText === 'Save') {
        isConfirm = true;
        e.preventDefault();
      }
    } else if (e === 'confirm') {
      isConfirm = true;
    }
    return isConfirm;
  };
  var _proto = Modal.prototype;
  _proto.render = function render() {
    var showFooter = this.props.showFooter !== undefined && this.props.showFooter !== null && !this.props.showFooter ? false : true;
    var okayButtonLabel = ModelHelper.validateNonEmpty(this.props.okBtnLabel) ? this.props.okBtnLabel : ModelHelper.validateNonEmpty(this.props.saveBtnLabel) ? this.props.saveBtnLabel : 'Okay';
    var cancelButtonLabel = this.props.cancelBtnLabel !== undefined && this.props.cancelBtnLabel !== null && this.props.cancelBtnLabel.length > 0 ? this.props.cancelBtnLabel : 'Cancel';
    var dialogId = '';
    if (this.props.modalContentName) {
      dialogId = this.props.modalContentName;
    } else {
      dialogId = this.props.title;
    }
    var okBtnProps = {};
    var showError = false;
    if (this.props.saveBtnLabel === undefined) {
      okBtnProps['action'] = 'confirm';
      showError = this.props.showError;
    }
    var dialogContentRefClass = this.props.isVideo ? 'mer-dialog__video-container' : '';
    var dialogContentRefContainerClass = this.props.isVideo ? 'p-0' : '';
    var dialogFooterClass = this.props.isVideo ? 'd-none' : 'mer-dialog__actions';
    return /*#__PURE__*/React.createElement(Dialog, {
      className: "mer-dialog",
      role: "dialog",
      autoStackButtons: false,
      id: dialogId,
      open: this.props.show,
      onClose: this.onModalClose,
      onOpen: this.onModalOpen
    }, /*#__PURE__*/React.createElement("button", {
      className: "mer-dialog__close",
      title: "Close",
      type: "button",
      onClick: this.onModalClose
    }), /*#__PURE__*/React.createElement(DialogContent, {
      tabIndex: "0",
      className: dialogContentRefContainerClass
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.dialogContentRef,
      className: dialogContentRefClass
    }, this.props.title && /*#__PURE__*/React.createElement(DialogTitle, {
      className: "mdc-dialog__title"
    }, this.props.title), this.props.children)), /*#__PURE__*/React.createElement(DialogFooter, {
      className: dialogFooterClass
    }, showFooter && (this.props.hideOkBtn === undefined || this.props.hideOkBtn === false) && /*#__PURE__*/React.createElement(DialogButton, _extends({}, okBtnProps, {
      className: "mer-button order-2 mer-button--" + (showError ? "critical" : "primary"),
      onClick: this.onModalOkay
    }), okayButtonLabel), showFooter && this.props.cancelBtnLabel && /*#__PURE__*/React.createElement(DialogButton, {
      action: "dismiss",
      className: "mer-button mer-button--secondary order-1",
      type: "button",
      onClick: this.onModalClose
    }, cancelButtonLabel), !showFooter && /*#__PURE__*/React.createElement(DialogButton, null)));
  };
  return Modal;
}(React.Component);
var ModalContentHelper = /*#__PURE__*/function () {
  function ModalContentHelper() {}
  ModalContentHelper.getModalContentData = function getModalContentData(modalContents, modalContentName) {
    var modalContentType = 'html';
    var displayContent = '  ';
    var selector = '';
    if (modalContentName !== undefined && modalContentName !== null && modalContentName.length > 0) {
      modalContentName = modalContentName.toLowerCase();
      var modalContent = modalContents.filter(function (content) {
        return content.name === modalContentName;
      });
      if (modalContent !== undefined && modalContent !== null && modalContent.length > 0) {
        if (modalContent[0].contentType !== undefined && modalContent[0].contentType !== '') {
          modalContentType = modalContent[0].contentType;
        }
        if (modalContent[0].content !== undefined && modalContent[0].content !== '') {
          displayContent = modalContent[0].content;
        }
        if (modalContent[0].selector !== undefined && modalContent[0].selector !== '') {
          selector = modalContent[0].selector;
        }
      }
    }
    return {
      modalContentType: modalContentType,
      displayContent: displayContent,
      selector: selector
    };
  };
  return ModalContentHelper;
}();
function Svg(props) {
  var svgContainer = props.con !== undefined ? "" + props.con : 'mer-svg-container';
  var svgCol = props.col !== undefined ? " " + props.col : '';
  var svgClass = "" + svgContainer + svgCol;
  var svgType = props.type !== undefined ? " " + props.type : 'img';
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: svgClass,
    role: svgType
  }, props), /*#__PURE__*/React.createElement("title", null, props.title), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + props.icon
  }));
}
Svg.defaultProps = {
  con: 'mer-svg-container',
  col: '',
  type: 'img'
};
var SimpleLinkModal = /*#__PURE__*/function (_React$Component) {
  function SimpleLinkModal(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this._isMounted = false;
    _this.closeModal = function (e) {
      if (Modal.isCancel(e)) {
        if (_this._isMounted) {
          _this.setState({
            isOpen: false
          });
        }
        _this.cancel();
      } else if (Modal.isConfirm(e)) {
        _this.confirm();
        if (_this._isMounted) {
          _this.setState({
            isOpen: false
          });
        }
      }
    };
    _this.toggleModal = function (e) {
      e.preventDefault();
      if (e.target.getAttribute('data-name') === 'showModal' || e.target.parentNode.getAttribute('data-name') === 'showModal') {
        _this.loadModal();
      }
    };
    _this.toggleModal = _this.toggleModal.bind(_this);
    _this.confirm = _this.confirm.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    var setup = ModalContentHelper.getModalContentData(_this.props.modalContents, _this.props.modalContentName);
    _this.state = {
      isOpen: false,
      modalContentType: setup.modalContentType,
      displayContent: setup.displayContent
    };
    return _this;
  }
  _inheritsLoose(SimpleLinkModal, _React$Component);
  var _proto = SimpleLinkModal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
  };
  _proto.loadModal = function loadModal() {
    var _this2 = this;
    if (!this.state.isOpen) {
      if (this._isMounted) {
        var setup = ModalContentHelper.getModalContentData(this.props.modalContents, this.props.modalContentName);
        if (setup.modalContentType === 'url') {
          console.log("Not supported, use the other link modal");
        } else {
          this.setState({
            isOpen: !this.state.isOpen,
            modalContentType: setup.modalContentType,
            displayContent: setup.displayContent
          }, function () {
            if (!_this2.state.isOpen) {
              _this2.confirm();
            }
          });
        }
      }
    }
  };
  _proto.confirm = function confirm() {
    if (this.props.onButtonClick !== undefined && this.props.onButtonClick !== null) {
      this.props.onButtonClick();
    }
  };
  _proto.cancel = function cancel() {
    if (this.props.onCancelButtonClick !== undefined && this.props.onCancelButtonClick !== null) {
      this.props.onCancelButtonClick();
    }
  };
  _proto.render = function render() {
    var linkClass = this.props.linkClass !== undefined && this.props.linkClass !== null && this.props.linkClass.length > 0 ? this.props.linkClass : '';
    var tabIndex = this.props.linkClass !== undefined && this.props.linkClass !== null && this.props.linkClass.length > 0 ? 0 : -1;
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.modalContentType === "html" && this.state.displayContent !== undefined && this.state.displayContent !== null && this.state.displayContent.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      "data-name": "showModal",
      className: linkClass,
      onClick: this.toggleModal,
      tabIndex: tabIndex
    }, this.props.icon !== undefined && this.props.icon !== null && this.props.icon.length > 0 && /*#__PURE__*/React.createElement(Svg, {
      icon: this.props.icon,
      className: this.props.iconClass
    }), this.props.displayContent), /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
      show: this.state.isOpen,
      onClose: this.closeModal,
      onOkay: this.toggleModal,
      title: this.props.title,
      cancelBtnLabel: this.props.cancelButtonLabel !== undefined || this.props.cancelButtonLabel !== null ? this.props.cancelButtonLabel : '',
      okBtnLabel: this.props.okayButtonLabel !== undefined ? this.props.okayButtonLabel : "Close",
      tabIndex: "-1"
    }), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.state.displayContent
      }
    }))));
  };
  return SimpleLinkModal;
}(React.Component);
SimpleLinkModal.defaultProps = {
  iconClass: '',
  enableGtm: true
};
var cheerio = require('cheerio');
function getWebsiteContent(url, selector, errorMessage) {
  return fetch(url).then(function (response) {
    if (response.ok) {
      return response.text();
    }
    console.log("failed response - status:" + response.status + " " + response.statusText);
    return errorMessage == undefined ? 'Could not get the content.' : errorMessage;
  }).then(function (html) {
    var $ = cheerio.load(html);
    return $(selector).html();
  })["catch"](function (error) {
    console.log(error);
    return errorMessage == undefined ? 'Could not get the content.' : errorMessage;
  });
}
var webscrape = {
  getWebsiteContent: getWebsiteContent
};
var errorLoadingMessage = "Error Loading";
var LinkModal = /*#__PURE__*/function (_React$Component) {
  function LinkModal(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.closeModal = function (e) {
      if (Modal.isCancel(e)) {
        _this.cancel();
        _this.setState({
          isOpen: false
        });
      } else if (Modal.isConfirm(e)) {
        _this.confirm();
        _this.setState({
          isOpen: false
        });
      }
    };
    _this.toggleModal = function (e) {
      if (e) {
        e.preventDefault();
        var clickedElement = e.target.closest("[data-name='showModal']");
        if (clickedElement) {
          clickedElement.blur();
        }
      }
      if (e.target.getAttribute('data-name') === 'showModal' || e.target.parentNode.getAttribute('data-name') === 'showModal') {
        if (!_this.state.isOpen) {
          var setup = ModalContentHelper.getModalContentData(_this.props.modalContents, _this.props.modalContentName);
          var displayContent = setup.displayContent;
          if (_this.props.querystring !== undefined && _this.props.querystring !== null) {
            displayContent += _this.props.querystring;
          }
          if (setup.modalContentType === 'url') {
            _this.setState({
              isOpen: true,
              isLoading: true,
              modalContentType: 'html'
            });
            _this.loadUrlContent(displayContent, setup.selector);
          } else {
            _this.setState({
              isOpen: true,
              modalContentType: setup.modalContentType,
              displayContent: setup.displayContent
            }, function () {
              if (!_this.state.isOpen) {
                _this.confirm();
              }
            });
          }
        }
      }
    };
    _this.onModalRetry = function (e) {
      _this.loadUrlContent(_this.state.displayContentUrl, _this.state.displayContentSelector);
    };
    var _setup = ModalContentHelper.getModalContentData(_this.props.modalContents, _this.props.modalContentName);
    _this.state = {
      isOpen: false,
      isLoading: false,
      modalContentType: _setup.modalContentType,
      displayContent: _setup.displayContent,
      displayContentUrl: '',
      displayContentSelector: '',
      event: ''
    };
    return _this;
  }
  _inheritsLoose(LinkModal, _React$Component);
  var _proto = LinkModal.prototype;
  _proto.loadUrlContent = function loadUrlContent(url, selector) {
    var _this2 = this;
    if (url === '' || selector === '') return;
    getWebsiteContent(url, selector, errorLoadingMessage).then(function (res) {
      _this2.setState({
        isOpen: true,
        isLoading: false,
        modalContentType: 'html',
        displayContent: res,
        displayContentUrl: url,
        displayContentSelector: selector
      }, function () {
        if (!_this2.state.isOpen) {
          _this2.confirm();
        }
      });
    });
  };
  _proto.confirm = function confirm() {
    if (this.props.onButtonClick !== undefined && this.props.onButtonClick !== null) {
      this.props.onButtonClick();
    }
  };
  _proto.cancel = function cancel() {
    if (this.props.onCancelButtonClick !== undefined && this.props.onCancelButtonClick !== null) {
      this.props.onCancelButtonClick();
    }
  };
  _proto.render = function render() {
    var linkClass = this.props.linkClass !== undefined && this.props.linkClass !== null && this.props.linkClass.length > 0 ? this.props.linkClass : '';
    var modalTitle = this.props.title;
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.useModal === 'false' && /*#__PURE__*/React.createElement("a", {
      href: this.props.href,
      target: "_blank"
    }, this.props.displayContent), this.props.useModal === "true" && this.state.modalContentType !== "video" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: "javascript:void(0);",
      className: linkClass,
      "data-name": "showModal",
      "data-test": "first load",
      onClick: this.toggleModal
    }, this.props.icon !== undefined && this.props.icon !== null && this.props.icon.length > 0 && /*#__PURE__*/React.createElement(Svg, {
      icon: this.props.icon,
      className: this.props.iconClass
    }), this.props.displayContent), this.state.modalContentType === "html" && !this.state.isLoading && this.state.displayContent !== undefined && this.state.displayContent !== null && this.state.displayContent.length > 0 && this.state.displayContent !== errorLoadingMessage && /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
      show: this.state.isOpen,
      onClose: this.closeModal,
      onOkay: this.toggleModal,
      title: modalTitle,
      okBtnLabel: this.props.okayButtonLabel,
      cancelBtnLabel: this.props.cancelButtonLabel,
      tabIndex: "-1"
    }), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.state.displayContent
      }
    })), this.state.modalContentType === "html" && this.state.isLoading && /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
      show: this.state.isOpen,
      onClose: this.closeModal,
      onOkay: this.toggleModal,
      title: "",
      okBtnLabel: this.props.okayButtonLabel,
      cancelBtnLabel: this.props.cancelButtonLabel,
      tabIndex: "-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "mer-loading-spinner",
      role: "alert",
      "aria-busy": "true"
    }, /*#__PURE__*/React.createElement("p", null, "Loading content"))), this.props.useModal === 'true' && this.state.modalContentType === 'html' && !this.state.isLoading && (this.state.displayContent === errorLoadingMessage || this.state.displayContent === null) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
      show: this.state.isOpen,
      onClose: this.closeModal,
      title: "",
      hideOkBtn: true,
      cancelBtnLabel: "Close",
      tabIndex: "-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("h2", null, "Failed to load content"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      className: "mer-button mer-button--primary",
      onClick: this.onModalRetry
    }, /*#__PURE__*/React.createElement("span", {
      className: "mer-color--gs-white"
    }, "Retry"))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: this.state.displayContentUrl,
      target: "blank"
    }, "Open in a new window"))))), this.state.modalContentType === "" && /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
      show: this.state.isOpen,
      onClose: this.toggleModal,
      title: modalTitle
    }), /*#__PURE__*/React.createElement("p", null, "Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero, non adipiscing dolor urna a orci. Vestibulum fringilla pede sit amet augue. Fusce fermentum odio nec arcu. Ut tincidunt tincidunt erat. Ut varius tincidunt libero."))), this.props.useModal === "true" && this.state.modalContentType === "iframe" && this.state.displayContent.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: "javascript:void(0);",
      onClick: this.toggleModal
    }, this.props.displayContent), /*#__PURE__*/React.createElement(Modal, {
      showFooter: false,
      show: this.state.isOpen,
      onClose: this.toggleModal,
      title: modalTitle
    }, /*#__PURE__*/React.createElement("iframe", {
      src: this.state.displayContent,
      allowFullScreen: true
    }))), this.state.modalContentType === "video" && !this.state.isLoading && this.state.displayContent !== undefined && this.state.displayContent !== null && this.state.displayContent.length > 0 && this.state.displayContent !== errorLoadingMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: "javascript:void(0);",
      onClick: this.toggleModal,
      className: "mer-svg-link mer-svg-link--before d-inline-flex align-items-center",
      "data-name": "showModal"
    }, /*#__PURE__*/React.createElement(Svg, {
      title: "Flowmoji play",
      col: "mer-svg-container--width-xs-12 mer-svg-container--width-xs mer-svg-container--height-xs mr-2",
      icon: "play-circle-fill"
    }), this.props.displayContent), /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
      show: this.state.isOpen,
      onClose: this.closeModal,
      tabIndex: "-1",
      isVideo: true
    }), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.state.displayContent
      }
    }))), this.props.useModal === 'true' && this.state.modalContentType === '' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: "javascript:void(0);",
      className: linkClass,
      onClick: this.toggleModal,
      "data-name": "showModal"
    }, this.props.icon !== undefined && this.props.icon !== null && this.props.icon.length > 0 && /*#__PURE__*/React.createElement(Svg, {
      icon: this.props.icon,
      className: this.props.iconClass
    }), this.props.displayContent), /*#__PURE__*/React.createElement(Modal, {
      show: this.state.isOpen,
      onClose: this.toggleModal,
      title: modalTitle
    }, /*#__PURE__*/React.createElement("div", null, "Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero,nt tincidunt erat. Ut varius tincidunt libero. Vivamus elementum semper nisi. Maecenas ullamcorper, dui et plm vivea couis evelit hendrerit rutrum. Quisque malesuada placerat nisar, hendrerit id, lorem. Pellentesque auctor neque nec urna."))));
  };
  return LinkModal;
}(React.Component);
LinkModal.defaultProps = {
  iconClass: '',
  linkClass: '',
  enableGtm: true
};
function Accordion(props) {
  var _useState = useState(''),
    setActive = _useState[0],
    setActiveState = _useState[1];
  var _useState2 = useState(''),
    setRotate = _useState2[0],
    setRotateState = _useState2[1];
  var _useState3 = useState('--hidden'),
    setContentClass = _useState3[0],
    setContentClassState = _useState3[1];
  function toggleAccordion(e) {
    e.preventDefault();
    var isActive = !(setActive === 'active');
    setActiveState(isActive ? 'active' : '');
    setRotateState(isActive ? 'rotate' : '');
    setContentClassState(isActive ? '' : '--hidden');
    if (props.onToggle !== undefined) {
      props.onToggle(e, props.id, isActive);
    }
  }
  var accordionCon = props.accordionCon !== undefined ? " " + props.accordionCon : '';
  var contentCon = props.contentCon !== undefined ? " " + props.contentCon : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "mer-accordion" + accordionCon
  }, /*#__PURE__*/React.createElement("button", {
    className: "mer-button mer-accordion__button mer-button--secondary " + setActive,
    onClick: toggleAccordion,
    type: "button"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mer-accordion__heading mdc-button__label"
  }, props.title), /*#__PURE__*/React.createElement(Svg, {
    title: "Chevron down",
    icon: "chevron-down",
    col: "mer-fill--primary-royal mer-accordion__icon " + setRotate,
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mer-accordion__content" + setContentClass + contentCon
  }, props.content));
}
Accordion.defaultProps = {
  id: '',
  content: '',
  title: '',
  contentCon: ''
};
function AccordionList(props) {
  var _useState = useState(),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var contentCon = props.contentCon !== undefined ? " " + props.contentCon : '';
  var accordionCon = props.accordionCon !== undefined ? " " + props.accordionCon : '';
  var accordionListSettings = props.settings;
  useEffect(function () {
    if (accordionListSettings) {
      if ('openFirstItem' in props.settings) {
        setActiveIndex(0);
      }
      return;
    }
  }, []);
  function toggleAccordion(e) {
    e.preventDefault();
    var currentAccordionBtn = e.currentTarget;
    var currentAccordionHeading = e.currentTarget.getAttribute('data-accordion-title');
    var currentAccordionScope = e.currentTarget.parentElement;
    var currentAccordionContentAriaLabel = currentAccordionBtn.nextElementSibling.getAttribute('aria-labelledby');
    var isCurrentExpanded = currentAccordionBtn.getAttribute('aria-expanded') === 'true' ? true : false;
    var accordionBtn = currentAccordionScope.querySelectorAll('.mer-accordion-list__button');
    [].forEach.call(accordionBtn, function (item) {
      item.setAttribute('aria-expanded', false);
    });
    if (isCurrentExpanded) {
      currentAccordionBtn.setAttribute('aria-expanded', 'false');
    } else {
      currentAccordionBtn.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        document.querySelector("[aria-labelledby='" + currentAccordionContentAriaLabel + "']").focus();
      }, 0);
      GtmHelper.sendGA4Accordion(currentAccordionHeading);
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mer-accordion-list" + accordionCon
  }, props.listData.map(function (accordionData, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement("button", {
      className: "mer-accordion-list__button",
      onClick: toggleAccordion,
      type: "button",
      "aria-expanded": activeIndex === index ? true : false,
      "aria-controls": "faq-item-" + (index + 1),
      "data-accordion-title": accordionData.title
    }, /*#__PURE__*/React.createElement("h5", {
      className: "mer-accordion-list__heading"
    }, /*#__PURE__*/React.createElement(Svg, {
      icon: "plus",
      col: "mer-accordion-list__icon",
      "aria-hidden": "true"
    }), accordionData.title)), /*#__PURE__*/React.createElement("div", {
      className: "mer-accordion-list__content" + contentCon,
      "aria-labelledby": "faq-item-" + (index + 1),
      tabIndex: "-1",
      dangerouslySetInnerHTML: {
        __html: accordionData.content
      }
    }));
  }));
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
const _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var LiveChat = function LiveChat() {
  var _useState = useState([]),
    payload = _useState[0],
    setPayload = _useState[1];
  var TurnOnChat = function TurnOnChat(enable) {
    ZendeskAPI('webWidget', 'updateSettings', {
      webWidget: {
        chat: {
          suppress: !enable
        }
      }
    });
  };
  useEffect(function () {
    var liveChatScript = document.getElementById('ze-snippet');
    var windowLocation = window.location.pathname;
    if (liveChatScript === null || liveChatScript === undefined) {
      var fetchLiveChatApi = function fetchLiveChatApi(url) {
        try {
          var _temp = _catch(function () {
            return Promise.resolve(Axios(url)).then(function (resultData) {
              setPayload(resultData.data);
            });
          }, function (error) {
            console.log('Error returning live chat result');
            console.log(error);
          });
          return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      };
      var fetchData = function fetchData() {
        return Promise.resolve(fetchLiveChatApi("/apis/seahorse/live-chat?path=" + windowLocation)).then(function () {});
      };
      fetchData();
    }
  }, []);
  function handleOnLoaded(isEnabled) {
    if (ZendeskAPI('webWidget:get', 'chat:isChatting') || isEnabled === 1) {
      TurnOnChat(true);
    } else {
      TurnOnChat(false);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(payload).length > 0 && parseInt(payload.isEnabled) === 1 && /*#__PURE__*/React.createElement(Zendesk, {
    id: "ze-snippet",
    zendeskKey: payload.key,
    onLoaded: handleOnLoaded(parseInt(payload.isEnabled))
  }));
};
var SCROLL_TO_EASE = 'inOutQuad';
var SCROLL_TO_DURATION = 10;
var scroller = function scroller(target, offset) {
  scrollToElement(target, {
    offset: -offset,
    ease: SCROLL_TO_EASE,
    duration: SCROLL_TO_DURATION
  });
};
var getHeaderHeight = function getHeaderHeight() {
  var isHeaderPresent = document.getElementsByClassName('mer-global-header');
  var headerHeight = isHeaderPresent.length > 0 ? document.querySelectorAll('header.mer-global-header')[0].offsetHeight : 0;
  return headerHeight;
};
var addressInputTouchEvents = function addressInputTouchEvents(target) {
  if (document.querySelector('html').classList.contains('touchevents')) {
    var closestFormFieldParent = target;
    scroller(closestFormFieldParent, getHeaderHeight());
  }
};
var scrollTo = function scrollTo(target) {
  scroller(target, getHeaderHeight());
};
var googleLogoContainerStyles = {
  textAlign: 'center',
  paddingTop: '.1875em',
  borderTop: '1px solid #d9d9d9'
};
var googleLogoStyles = {
  width: '7.1875em'
};
var LocationSearchInput = /*#__PURE__*/function (_React$Component) {
  function LocationSearchInput(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.renderFunc = function (_ref) {
      var getInputProps = _ref.getInputProps,
        suggestions = _ref.suggestions,
        getSuggestionItemProps = _ref.getSuggestionItemProps;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "mdc-text-field mdc-text-field--outlined mdc-text-field--no-label"
      }, /*#__PURE__*/React.createElement("input", _extends({}, getInputProps({
        className: 'location-search-input mdc-text-field__input'
      }), {
        id: _this.props.id !== undefined ? _this.props.id : _this.props.name,
        placeholder: _this.props.placeholder,
        name: _this.props.name,
        onBlur: _this.onBlur,
        onFocus: _this.onFocus,
        value: _this.state.address,
        maxLength: 240,
        required: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "mdc-notched-outline"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mdc-notched-outline__leading"
      }), /*#__PURE__*/React.createElement("div", {
        className: "mdc-notched-outline__trailing"
      })), suggestions.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "autocomplete-dropdown-container pac-container pac-container--popout text-left"
      }, suggestions.map(function (suggestion, index) {
        var className = suggestion.active ? 'pac-item pac-item-query suggestion-item--active pac-item-selected' : 'pac-item suggestion-item';
        var description = suggestion.description;
        if (suggestion.matchedSubstrings !== undefined && suggestion.matchedSubstrings !== null && suggestion.matchedSubstrings.length > 0) {
          var replacementNum = 0;
          for (var key in suggestion.matchedSubstrings) {
            var match = suggestion.matchedSubstrings[key];
            var offset = match.offset + 2 * replacementNum;
            var length = match.length;
            replacementNum = replacementNum + 1;
            description = description.slice(0, offset) + '<' + description.slice(offset);
            description = description.slice(0, offset + length + 1) + '!' + description.slice(offset + length + 1);
          }
          if (description.split(',').length > 1) {
            description = description.split(',')[0] + description.split(',')[1];
          }
          description = description.replace(/</g, '<strong class="pac-matched">').replace(/!/g, '</strong>').replace(/,/, '');
        }
        return /*#__PURE__*/React.createElement("div", _extends({}, getSuggestionItemProps(suggestion, {
          className: className
        }), {
          key: index
        }), /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: description
          }
        }));
      }), /*#__PURE__*/React.createElement("div", {
        style: googleLogoContainerStyles
      }, /*#__PURE__*/React.createElement("img", {
        style: googleLogoStyles,
        src: _this.props.mermaidUrl + "/-/img/powered-by-google-on-white.png",
        alt: "Powered by Google"
      }))), _this.props.caption && /*#__PURE__*/React.createElement("span", {
        className: "mer-form-field__descriptor"
      }, _this.props.caption)));
    };
    _this.handleChange = function (address) {
      _this.setState({
        address: address
      });
      if (_this.props.onChange !== undefined) {
        _this.props.onChange(address);
      }
    };
    _this.handleSelect = function (address, placeId) {
      if (address.split(',').length > 1) {
        address = address.split(',')[0] + address.split(',')[1];
      }
      _this.setState({
        address: address
      });
      if (_this.props.onSelect !== undefined) {
        _this.props.onSelect(address);
      }
    };
    _this.handleError = function (status, clearSuggestions) {
      console.log('Google Maps API returned error with status: ', status);
      clearSuggestions();
    };
    _this.state = {
      address: _this.props.initialValue
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.searchOptions = {
      location: props.setInitialLocation !== undefined ? new window.google.maps.LatLng(-32, 116) : null,
      radius: 2000,
      types: ['address'],
      componentRestrictions: {
        country: 'au'
      }
    };
    return _this;
  }
  _inheritsLoose(LocationSearchInput, _React$Component);
  var _proto = LocationSearchInput.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.initialValue !== this.props.initialValue && this.props.initialValue === 'reset' && this.state.address !== '') {
      this.handleChange('');
    }
  };
  _proto.onBlur = function onBlur(e) {
    var target = e.target;
    var targetParent = target.parentElement;
    targetParent.classList.remove('mdc-text-field--focused');
    if (targetParent.querySelector('.pac-container')) {
      targetParent.querySelector('.pac-container').classList.add('d-none');
    }
  };
  _proto.onFocus = function onFocus(e) {
    var target = e.target;
    var targetParent = target.parentElement;
    targetParent.classList.add('mdc-text-field--focused');
    if (targetParent.querySelector('.pac-container')) {
      targetParent.querySelector('.pac-container').classList.remove('d-none');
    }
    var targetClosestField = target.closest('.mer-form__field');
    addressInputTouchEvents(targetClosestField);
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(PlacesAutocomplete, {
      value: this.state.address,
      onChange: this.handleChange,
      onSelect: this.handleSelect,
      searchOptions: this.searchOptions,
      highlightFirstSuggestion: true,
      shouldFetchSuggestions: this.state.address.length > 0,
      onError: this.handleError,
      clearItemsOnError: true
    }, this.renderFunc);
  };
  return LocationSearchInput;
}(React.Component);
var LocationSearch = function LocationSearch(_ref) {
  var initialAddress = _ref.initialAddress,
    textAboveTextbox = _ref.textAboveTextbox,
    onAddressChange = _ref.onAddressChange,
    onSearchButtonClick = _ref.onSearchButtonClick,
    mermaidUrl = _ref.mermaidUrl,
    serviceTypes = _ref.serviceTypes,
    onUseCurrentLocationClick = _ref.onUseCurrentLocationClick,
    handleFilterResults = _ref.handleFilterResults;
  var _useState = useState(initialAddress),
    address = _useState[0],
    setAddress = _useState[1];
  function handleClick(e) {
    e.preventDefault();
    setAddress(address);
    if (onSearchButtonClick !== undefined && onSearchButtonClick !== null) {
      onSearchButtonClick(address, false);
    }
  }
  function handleChange(address) {
    setAddress(address);
    if (onAddressChange !== undefined) {
      onAddressChange(address);
    }
  }
  function handleSelect(address) {
    setAddress(address);
    if (onSearchButtonClick !== undefined && onSearchButtonClick !== null) {
      onSearchButtonClick(address, false);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 col-lg-2 d-flex align-items-start justify-content-center"
  }, textAboveTextbox === null && /*#__PURE__*/React.createElement("img", {
    src: mermaidUrl + "/-/img/icons/generic/happy-location.svg",
    alt: "Happy location flowmoji",
    width: "120"
  }), textAboveTextbox !== null && /*#__PURE__*/React.createElement("img", {
    src: mermaidUrl + "/-/img/icons/generic/unhappy-location.svg",
    alt: "Unhappy location flowmoji",
    width: "120"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm-10 col-md-7 col-lg-5 ml-md-4 text-center text-md-left"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mer-typography--headline2 my-0"
  }, "Find gas cylinders near you"), textAboveTextbox, /*#__PURE__*/React.createElement("form", {
    className: "mer-form"
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 mer-form__field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "mer-form-label-required",
    htmlFor: "addressSearch.address"
  }, "Enter your address"), /*#__PURE__*/React.createElement("div", {
    className: "mer-form__field-action mer-form__field-action--flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mdc-text-field mdc-text-field--outlined mdc-text-field--no-label mer-flex--auto mer-z-index--base"
  }, /*#__PURE__*/React.createElement(LocationSearchInput, {
    initialValue: initialAddress,
    name: "addressSearch.address",
    placeholder: "Enter your address",
    fieldLabel: "Enter your address",
    mermaidUrl: mermaidUrl,
    onChange: handleChange,
    onSelect: handleSelect,
    setInitialLocation: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "mdc-notched-outline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mdc-notched-outline__leading"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mdc-notched-outline__trailing"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    className: "mer-button mer-button--primary"
  }, /*#__PURE__*/React.createElement(Svg, {
    title: "Chevron right",
    icon: "chevron-right",
    col: "mer-fill--gs-white mer-svg-container--size-xs d-sm-none",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-sm-block"
  }, "Find locations")))))), /*#__PURE__*/React.createElement("fieldset", {
    className: "mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: onUseCurrentLocationClick
  }, "Or use your current location")), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Accordion, {
    id: "filter-services",
    title: "Filter results",
    contentCon: "text-left",
    accordionCon: "mer-bg--gs-white",
    content: /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-12 mer-form__field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mer-form-fields mer-form-fields--flex-column"
    }, Array.isArray(serviceTypes) && serviceTypes.map(function (services, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "mdc-form-field",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "mdc-checkbox"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        className: "mdc-checkbox__native-control",
        id: services.key,
        value: services.key,
        defaultChecked: true,
        onChange: handleFilterResults,
        name: "location-services"
      }), /*#__PURE__*/React.createElement("div", {
        className: "mdc-checkbox__background"
      }, /*#__PURE__*/React.createElement("svg", {
        className: "mdc-checkbox__checkmark",
        viewBox: "0 0 24 24"
      }, /*#__PURE__*/React.createElement("path", {
        className: "mdc-checkbox__checkmark-path",
        fill: "none",
        d: "M1.73,12.91 8.1,19.28 22.79,4.59"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mdc-checkbox__mixedmark"
      })), /*#__PURE__*/React.createElement("label", {
        htmlFor: services.key
      }, services.value)));
    }))))
  })))))));
};
LocationSearch.defaultProps = {
  initialAddress: '',
  textAboveTextbox: null
};
var DirectionsButton = function DirectionsButton(_ref) {
  var lat = _ref.lat,
    lng = _ref.lng,
    srclat = _ref.srclat,
    srclng = _ref.srclng;
  var showDirections = function showDirections(e) {
    try {
      e.preventDefault();
      if (srclat !== undefined && srclat !== null && srclng !== undefined && srclng !== null && lat !== undefined && lat !== null && lng !== undefined && lng !== null) {
        window.open("https://www.google.com/maps/dir/?api=1&origin=" + Number(srclat) + "," + Number(srclng) + "&destination=" + Number(lat) + "," + Number(lng), '_blank');
      } else {
        window.open("https://www.google.com/maps/dir/?api=1&destination=" + Number(lat) + "," + Number(lng), '_blank');
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, srclat !== undefined && srclat !== null && srclng !== undefined && srclng !== null && lat !== undefined && lat !== null && lng !== undefined && lng !== null && /*#__PURE__*/React.createElement("a", {
    href: "https://www.google.com/maps/dir/?api=1&origin=" + Number(srclat) + "," + Number(srclng) + "&destination=" + Number(lat) + "," + Number(lng),
    onClick: showDirections,
    title: "Click to find directions",
    className: "mer-button mer-button--primary mer-width-100"
  }, "Directions"), srclat === undefined || srclat === null || srclng === undefined || srclng === null && lat !== undefined && lat !== null && lng !== undefined && lng !== null && /*#__PURE__*/React.createElement("a", {
    href: "https://www.google.com/maps/dir/?api=1&origin=destination=" + Number(lat) + "," + Number(lng),
    onClick: showDirections,
    title: "Click to find directions",
    className: "mer-button mer-button--primary mer-width-100"
  }, "Directions"));
};
var LocationCard = function LocationCard(_ref) {
  var postId = _ref.postId,
    locationId = _ref.locationId,
    locationName = _ref.locationName,
    address = _ref.address,
    distance = _ref.distance,
    products = _ref.products,
    lat = _ref.lat,
    lng = _ref.lng,
    srclat = _ref.srclat,
    srclng = _ref.srclng,
    phone = _ref.phone,
    redirectForDetail = _ref.redirectForDetail,
    serviceTypes = _ref.serviceTypes;
  var history = useHistory();
  function handleClick(e) {
    if (e !== undefined && e !== null) {
      e.preventDefault();
    }
    console.log("navigating to " + locationId);
    if (redirectForDetail) {
      window.open("/locations/" + locationId + "?dist=" + distance.toString() + "&srclat=" + srclat.toString() + "&srclng=" + srclng.toString());
    } else {
      history.push({
        pathname: "/locations/" + locationId,
        state: {
          locationDetail: {
            post_title: locationName,
            address: address,
            lat: lat,
            lng: lng,
            srclat: srclat,
            srclng: srclng,
            distance: distance,
            phone: phone,
            services: products
          }
        }
      });
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm-6 col-lg-4",
    key: postId
  }, /*#__PURE__*/React.createElement("div", {
    className: "mer-card mdc-card mer-card--height-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mer-card-primary-action px-3 pt-3 pb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-left mr-3 mb-2",
    style: {
      width: 40,
      height: 40
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: process.env.MERMAID_URL + "/-/img/icons/generic/google-map.svg",
    alt: ""
  })), /*#__PURE__*/React.createElement("h3", {
    className: "mer-typography--headline5 mt-0 mb-0"
  }, locationName), /*#__PURE__*/React.createElement("span", {
    className: "mer-color--gs-grey-dark"
  }, parseFloat(distance).toFixed(1), "km"), /*#__PURE__*/React.createElement("ul", {
    className: "mer-list mer-list-icon mx-0"
  }, Array.isArray(products) && products.map(function (item, index) {
    var matchingService = serviceTypes.filter(function (x) {
      return x.key.toUpperCase() === item.toUpperCase();
    });
    if (matchingService !== undefined && matchingService !== null && matchingService.length > 0) {
      return /*#__PURE__*/React.createElement("li", {
        key: index,
        className: "mer-list__item mer-list__item-size--xs"
      }, /*#__PURE__*/React.createElement(Svg, {
        title: "Tick",
        icon: "tick",
        con: "mer-list__item-icon",
        col: "mer-fill--gs-grey",
        "aria-hidden": "true"
      }), matchingService[0].value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mer-card-action-container mdc-card__actions mer-border-0 px-3 pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mer-button-group mer-width-100 mer-button-group--flex-row"
  }, /*#__PURE__*/React.createElement(DirectionsButton, {
    lat: lat,
    lng: lng,
    srclat: srclat,
    srclng: srclng
  }), /*#__PURE__*/React.createElement("a", {
    href: "/locations/" + locationId + "?dist=" + distance.toString() + "&srclat=" + srclat.toString() + "&srclng=" + srclng.toString(),
    onClick: handleClick,
    title: "Click to open new tab",
    className: "mer-button mer-button--secondary mer-width-100"
  }, "More info"))))));
};
function getCookieValue(name) {
  return Cookies.get(name);
}
function setCookie(name, value, expiryInDays) {
  var secure = true;
  if (process.env.NODE_ENV !== 'production') {
    secure = false;
  }
  console.log('ishttps');
  console.log(secure);
  Cookies.set(name, value, {
    expires: expiryInDays,
    secure: secure,
    sameSite: 'strict'
  });
}
function deleteCookie(name) {
  Cookies.remove(name);
}
var Locations = function Locations(_ref) {
  var mermaidUrl = _ref.mermaidUrl,
    locationSearchUrl = _ref.locationSearchUrl,
    redirectForDetail = _ref.redirectForDetail,
    addressCookieName = _ref.addressCookieName,
    cookieExpiry = _ref.cookieExpiry,
    serviceTypes = _ref.serviceTypes;
  var NUM_ITEM_PER_LOAD = 6;
  var _useState = useState(false),
    isLocationSearchInprogress = _useState[0],
    setIsLocationSearchInprogress = _useState[1];
  var _useState2 = useState(null),
    addressWithGeocode = _useState2[0],
    setAddressWithGeocode = _useState2[1];
  var _useState3 = useState(null),
    locations = _useState3[0],
    setLocations = _useState3[1];
  var _useState4 = useState(false),
    isAddressNotFound = _useState4[0],
    setIsAddressNotFound = _useState4[1];
  var _useState5 = useState(''),
    initialAddress = _useState5[0],
    setInitialAddress = _useState5[1];
  var _useState6 = useState(serviceTypes),
    filterOptions = _useState6[0],
    setFilterOptions = _useState6[1];
  function onSearchButtonClick(address) {
    setInitialAddress('');
    runAddressSearch(address, NUM_ITEM_PER_LOAD / 2 + 1);
  }
  var onUseCurrentLocationClick = function onUseCurrentLocationClick(e) {
    try {
      e.preventDefault();
      setInitialAddress('reset');
      var _temp = function () {
        if ("geolocation" in navigator) {
          return Promise.resolve(navigator.geolocation.getCurrentPosition(function (position) {
            console.log("Latitude is :", position.coords.latitude);
            console.log("Longitude is :", position.coords.longitude);
            runAddressSearch('your current location', NUM_ITEM_PER_LOAD / 2 + 1, position.coords.latitude, position.coords.longitude);
          }, function (err) {
            return console.log(err);
          })).then(function () {});
        } else {
          console.log("geolocation not available");
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  function LoadMoreLocation(e) {
    e.preventDefault();
    runAddressSearch(addressWithGeocode.searchAddress, locations.count + NUM_ITEM_PER_LOAD);
  }
  function resetSearch() {
    setInitialAddress('reset');
    setAddressWithGeocode(null);
    setLocations(null);
    setIsAddressNotFound(false);
  }
  function runAddressSearch(searchAddress, numOfLocationsToDisplay, lat, lng) {
    if (lat === void 0) {
      lat = null;
    }
    if (lng === void 0) {
      lng = null;
    }
    if (isLocationSearchInprogress || searchAddress === null || addressWithGeocode !== null && addressWithGeocode.searchAddress === searchAddress && locations !== null && locations.count === numOfLocationsToDisplay) {
      return;
    }
    setIsLocationSearchInprogress(true);
    setIsAddressNotFound(false);
    if (lat !== undefined && lat !== null && lng !== undefined && lng !== null && lng !== undefined) {
      var geocodeAddy = {
        searchAddress: searchAddress,
        lat: lat,
        lng: lng
      };
      setAddressWithGeocode(geocodeAddy);
      runLocationSearch(geocodeAddy, numOfLocationsToDisplay);
    } else {
      if (addressWithGeocode === null || addressWithGeocode.searchAddress !== searchAddress) {
        if (addressCookieName !== undefined && addressCookieName !== null && addressCookieName.length > 0) {
          console.log('existing address in cookie');
          var cookieValue = getCookieValue(addressCookieName);
          console.log(cookieValue);
          deleteCookie(addressCookieName);
          setCookie(addressCookieName, searchAddress, cookieExpiry);
        }
        geocodeByAddress(searchAddress).then(function (results) {
          return getLatLng(results[0]);
        }).then(function (_ref2) {
          var lat = _ref2.lat,
            lng = _ref2.lng;
          var geocodeAddy = {
            searchAddress: searchAddress,
            lat: lat,
            lng: lng
          };
          setAddressWithGeocode(geocodeAddy);
          runLocationSearch(geocodeAddy, numOfLocationsToDisplay);
        })["catch"](function (err) {
          console.log('error:', err);
          setIsAddressNotFound(true);
          setAddressWithGeocode(null);
          setLocations(null);
          setIsLocationSearchInprogress(false);
          return;
        });
      } else if (locations === null || locations.count !== numOfLocationsToDisplay) {
        runLocationSearch(addressWithGeocode, numOfLocationsToDisplay);
      }
    }
  }
  function runLocationSearch(geocode, count) {
    console.log('runLocationSearch');
    var query = locationSearchUrl + "?lat=" + geocode.lat + "&lng=" + geocode.lng + "&count=" + count + "&radius=50";
    var filterOptionsQuery = [];
    filterOptions.map(function (option) {
      if (option.checked) {
        filterOptionsQuery.push(option.key);
      }
    });
    console.log('filterOptionsQuery: ', filterOptionsQuery);
    if (filterOptionsQuery.length > 0) {
      query = query + "&products=" + encodeURI(filterOptionsQuery.toString());
    }
    console.log("query: " + query);
    fetch(query).then(function (response) {
      return response.json();
    })["catch"](function (error) {
      console.log(error);
      setLocations(null);
      setIsLocationSearchInprogress(false);
    }).then(function (apiResponse) {
      setLocations({
        count: count,
        data: apiResponse
      });
      setIsLocationSearchInprogress(false);
    });
  }
  function handleFilterResults(e) {
    var value = e.target.value;
    var checked = e.target.checked;
    var filterOptionsArr = filterOptions;
    var spliceIndex;
    var relatedFilteredOptionIndex = filterOptionsArr.findIndex(function (x) {
      return x.key === value;
    });
    filterOptionsArr.filter(function (x) {
      return x.key === value;
    }).map(function (option) {
      if (relatedFilteredOptionIndex === 0) {
        spliceIndex = 1;
      } else {
        spliceIndex = relatedFilteredOptionIndex;
      }
      filterOptionsArr.splice(relatedFilteredOptionIndex, spliceIndex, {
        value: option.value,
        key: value,
        checked: checked
      });
    });
    console.log(relatedFilteredOptionIndex);
    console.log('filterOptionsArr: ', filterOptionsArr);
    setFilterOptions(filterOptionsArr);
    if (addressWithGeocode) {
      runLocationSearch(addressWithGeocode, NUM_ITEM_PER_LOAD / 2 + 1);
    }
  }
  function displayLocations() {
    var items = [];
    var maxIndex = locations.count - 1;
    for (var _iterator = _createForOfIteratorHelperLoose(locations.data.entries()), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        index = _step$value[0],
        x = _step$value[1];
      if (index >= maxIndex) break;
      items.push(/*#__PURE__*/React.createElement(LocationCard, {
        key: 'loccard-' + index,
        postId: x.ID,
        locationId: x.post_name,
        locationName: x.post_title,
        address: x.address,
        distance: x.distance,
        products: x.services,
        lat: x.lat,
        lng: x.lng,
        srclat: addressWithGeocode !== undefined && addressWithGeocode !== null ? addressWithGeocode.lat : null,
        srclng: addressWithGeocode != undefined && addressWithGeocode !== null ? addressWithGeocode.lng : null,
        phone: x.phone,
        redirectForDetail: redirectForDetail,
        serviceTypes: serviceTypes
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, items);
  }
  var isNoLocationFound = locations !== undefined && locations !== null && Array.isArray(locations.data) && locations.data.length === 0;
  return /*#__PURE__*/React.createElement("section", {
    className: "module-wrapper mer-py-lg mer-px-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/React.createElement(LocationSearch, {
    initialAddress: initialAddress,
    textAboveTextbox: isAddressNotFound ? /*#__PURE__*/React.createElement("p", {
      className: "mer-color--primary-royal"
    }, "Sorry, we couldn't find that address. Could you try again?") : isNoLocationFound ? /*#__PURE__*/React.createElement("p", {
      className: "mer-color--primary-royal"
    }, "Sorry, we couldn't find any locations near that address. Please try another address.") : null,
    onSearchButtonClick: onSearchButtonClick,
    mermaidUrl: mermaidUrl,
    serviceTypes: serviceTypes,
    onUseCurrentLocationClick: onUseCurrentLocationClick,
    handleFilterResults: handleFilterResults
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-10"
  }, addressWithGeocode !== undefined && addressWithGeocode !== null && !isNoLocationFound && /*#__PURE__*/React.createElement("p", {
    className: "mer-typography--headline4 text-center"
  }, "Locations near ", addressWithGeocode.searchAddress, ".", /*#__PURE__*/React.createElement("a", {
    className: "mer-font--weight-bolder ml-2",
    href: "#",
    title: "Click to reset search",
    onClick: resetSearch
  }, "Change?")), locations !== undefined && locations !== null && Array.isArray(locations.data) && /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, displayLocations(), locations.data.length === locations.count && /*#__PURE__*/React.createElement("button", {
    className: "mer-button mer-button--secondary mer-width-100 mt-3",
    onClick: LoadMoreLocation
  }, "More locations"))))));
};
Locations.defaultProps = {};
var NoticeBar = function NoticeBar(_ref) {
  var useReactApi = _ref.useReactApi;
  var _useState = useState([]),
    payload = _useState[0],
    setPayload = _useState[1];
  useEffect(function () {
    var windowLocation = window.location.pathname;
    console.log("windowLocation: " + windowLocation);
    console.log("useReactApi: " + useReactApi);
    var fetchuseReactApi = function fetchuseReactApi(url) {
      try {
        var _temp = _catch(function () {
          return Promise.resolve(Axios(url)).then(function (resultData) {
            setPayload(resultData.data);
            console.log('Notice bar - resultData.data', resultData.data);
          });
        }, function (error) {
          console.log('Error returning notice bar result');
          console.log(error);
        });
        return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    var fetchData = function fetchData() {
      return Promise.resolve(fetchuseReactApi("/apis/seahorse/notice-bar?path=" + windowLocation)).then(function () {});
    };
    fetchData();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(payload).length > 0 && parseInt(payload.isEnabled) === 1 && useReactApi === true && /*#__PURE__*/React.createElement("section", {
    id: "notice-bar",
    "data-contentoffset": "true",
    className: "mer-theme--light mer-bg--gs-grey-lighter mer-py-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mer-notice-bar mer-notice-bar-svg"
  }, /*#__PURE__*/React.createElement(Svg, {
    title: "Information",
    icon: "information-circle",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "mer-notice-bar__title",
    "data-notice-bar": "title"
  }, payload.title), /*#__PURE__*/React.createElement("div", {
    className: "mer-notice-bar__description-container"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: payload.copy
    }
  })))))), useReactApi === false && /*#__PURE__*/React.createElement("section", {
    id: "notice-bar",
    "data-contentoffset": "true",
    className: "mer mer-theme--light mer-bg--gs-grey-lighter mer-py-sm",
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mer-notice-bar mer-notice-bar-svg"
  }, /*#__PURE__*/React.createElement(Svg, {
    title: "Information",
    icon: "information-circle",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "mer-notice-bar__title",
    "data-notice-bar": "title"
  }, "Title"), /*#__PURE__*/React.createElement("p", {
    className: "mer-notice-bar__description",
    "data-notice-bar": "description"
  }, "Description"))))));
};
export { Accordion, AccordionList, DirectionsButton, GtmHelper, Label, Label$1 as Label1, LinkModal, LiveChat, LocationCard, LocationSearch, LocationSearchInput, Locations, Modal, ModalContentHelper, NoticeBar, SCROLL_TO_DURATION, SCROLL_TO_EASE, SimpleLinkModal, Svg, addressInputTouchEvents, deleteCookie, getCookieValue, webscrape as getWebsiteContent, scrollTo, setCookie };